import type { PricingContent } from "../types";
import { HI_FAQS } from "./home";

export const HI_PRICING: PricingContent = {
  seoTitle: "Crayo Pricing | हर creator के लिए plans",
  seoDescription:
    "AI short-form video के लिए simple और transparent pricing। हर plan में workflow credits, voiceovers, AI images, storage और social tracking।",
  name: "Crayo Pricing",
  crumb: "Pricing",
  h1: "Pricing",
  subheading: "हर plan में Crayo के सारे tools शामिल हैं। बस चुनें कि आप कितना बनाते हैं।",
  faqs: [
    ...HI_FAQS,
    {
      question: "Crayo की तुलना Opus Clip, CapCut और Submagic से कैसी है?",
      answer:
        "Crayo हर finished video पर एक workflow credit लेता है और हर plan में सारे tools देता है। Opus Clip upload किए गए source minutes के हिसाब से charge करता है, CapCut का कोई public pricing page नहीं है, और Submagic credits, video count और per-video minutes तीनों पर एक साथ limit लगाता है। Comparison hub में हर एक के dated, source-linked prices और features दिए हैं।",
      link: { href: "/compare", label: "सारी comparisons देखें" },
    },
  ],
};
